import { Browser } from '@capacitor/browser';
import { supabase } from './supabase';
import { isNative, OAUTH_REDIRECT_NATIVE, OAUTH_REDIRECT_WEB } from './platform';

export type OAuthProvider = 'google' | 'apple';

/**
 * Start an OAuth sign-in. On the web this performs a normal full-page redirect.
 * On native we ask Supabase for the provider URL, open it in the system in-app
 * browser, and let the `appUrlOpen` deep-link handler (see lib/native.ts)
 * complete the PKCE code exchange when the provider redirects back.
 */
export async function signInWithProvider(provider: OAuthProvider): Promise<void> {
  const redirectTo = isNative ? OAUTH_REDIRECT_NATIVE : OAUTH_REDIRECT_WEB;

  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo,
      skipBrowserRedirect: isNative,
    },
  });

  if (error) throw error;

  if (isNative && data?.url) {
    await Browser.open({ url: data.url, presentationStyle: 'popover' });
  }
  // On web, supabase-js has already navigated the page to the provider.
}
